import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum ReservationHistoryRecordTypeId {
  RESERVATION_CREATED = 'ReservationCreated',
  RESERVATION_UPDATED = 'ReservationUpdated',
  GROUP_RESERVATION_CREATED = 'GroupReservationCreated',
  GROUP_RESERVATION_UPDATED = 'GroupReservationUpdated',
  RESERVATION_DELETED = 'ReservationDeleted',
  RESERVATION_ASSIGNED = 'ReservationAssigned',
  RESERVATION_UNASSIGNED = 'ReservationUnassigned',
  UNASSIGNED_RESERVATION_CREATED = 'UnassignedReservationCreated',
  UNASSIGNED_RESERVATION_UPDATED = 'UnassignedReservationUpdated',
  UNASSIGNED_RESERVATION_DELETED = 'UnassignedReservationDeleted',
  RESERVATION_ADDED_TO_GROUP = 'ReservationAddedToGroup',
  RESERVATION_REMOVED_FROM_GROUP = 'ReservationRemovedFromGroup',
  UNASSIGNED_RESERVATION_ADDED_TO_GROUP = 'UnassignedReservationAddedToGroup',
  UNASSIGNED_RESERVATION_REMOVED_FROM_GROUP = 'UnassignedReservationRemovedFromGroup',
  NO_SHOW_REPORTED = 'NoShowReported',
  RESERVATION_CONVERSION = 'ReservationConversion',
  VOUCHER_SENT = 'VoucherSent',
  CREDIT_CARD_DISPLAYED = 'CreditCardDisplayed',
  CREDIT_CARD_DELETED = 'CreditCardDeleted',
  CREDIT_CARD_REPORTED_INVALID = 'CreditCardReportedInvalid',
  CREDIT_CARD_CANCELLATION_REPORTED = 'CreditCardCancellationReported',
  INVOICE_CREATED = 'InvoiceCreated',
  INVOICE_UPDATED = 'InvoiceUpdated',
  INVOICE_DELETED = 'InvoiceDeleted',
  INVOICE_SENT = 'InvoiceSent',
  INVOICE_ASSIGNED_TO_RESERVATION = 'InvoiceAssignedToReservation',
  INVOICE_REMOVED_FROM_RESERVATION = 'InvoiceRemovedFromReservation',
  BONUS_APPROVAL = 'BonusApproval',
  EQC_SEND = 'EqcSend',
  PAYMENT_CREATED = 'PaymentCreated',
  PAYMENT_DELETED = 'PaymentDeleted',
  EMAIL_SENT = 'EmailSent',
  SMS_SENT = 'SmsSent',
  AIRBNB_MESSAGE = 'AirbnbMessage',
  BOOKING_COM_MESSAGE = 'BookingComMessage',
  CONTACT_PERSON_ADDED = 'ContactPersonAdded',
  CONTACT_PERSON_UPDATED = 'ContactPersonUpdated',
  CONTACT_PERSON_REMOVED = 'ContactPersonRemoved',
  CONTACT_PERSON_CREATED = 'ContactPersonCreated',
  CONTACT_PERSON_RECORD_UPDATED = 'ContactPersonRecordUpdated',
  CONTACT_PERSON_DELETED = 'ContactPersonDeleted',
  NOTE_ADDED = 'NoteAdded',
  NOTE_UPDATED = 'NoteUpdated',
  NOTE_DELETED = 'NoteDeleted',
  RESERVATION_NOTE_ADDED = 'ReservationNoteAdded',
  RESERVATION_NOTE_UPDATED = 'ReservationNoteUpdated',
  RESERVATION_NOTE_DELETED = 'ReservationNoteDeleted',
}

export class ReservationHistoryRecordType extends Codebook<ReservationHistoryRecordTypeId> {
  static readonly RESERVATION_CREATED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.RESERVATION_CREATED,
    () => $t('New reservation created'),
  )
  static readonly RESERVATION_UPDATED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.RESERVATION_UPDATED,
    () => $t('Reservation edited'),
  )
  static readonly GROUP_RESERVATION_CREATED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.GROUP_RESERVATION_CREATED,
    () => $t('New reservation created'),
  )
  static readonly GROUP_RESERVATION_UPDATED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.GROUP_RESERVATION_UPDATED,
    () => $t('Reservation edited'),
  )
  static readonly RESERVATION_DELETED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.RESERVATION_DELETED,
    () => $t('Reservation deleted'),
  )
  static readonly RESERVATION_ASSIGNED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.RESERVATION_ASSIGNED,
    () => $t('Reservation assigned'),
  )
  static readonly RESERVATION_UNASSIGNED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.RESERVATION_UNASSIGNED,
    () => $t('Reservation unassigned'),
  )
  static readonly UNASSIGNED_RESERVATION_CREATED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.UNASSIGNED_RESERVATION_CREATED,
    () => $t('Unassigned reservation created'),
  )
  static readonly UNASSIGNED_RESERVATION_UPDATED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.UNASSIGNED_RESERVATION_UPDATED,
    () => $t('Unassigned reservation updated'),
  )
  static readonly UNASSIGNED_RESERVATION_DELETED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.UNASSIGNED_RESERVATION_DELETED,
    () => $t('Unassigned reservation deleted'),
  )
  static readonly RESERVATION_ADDED_TO_GROUP = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.RESERVATION_ADDED_TO_GROUP,
    () => $t('Reservation added to group'),
  )
  static readonly RESERVATION_REMOVED_FROM_GROUP = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.RESERVATION_REMOVED_FROM_GROUP,
    () => $t('Reservation removed from group'),
  )
  static readonly UNASSIGNED_RESERVATION_ADDED_TO_GROUP = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.UNASSIGNED_RESERVATION_ADDED_TO_GROUP,
    () => $t('Unassigned reservation added to group'),
  )
  static readonly UNASSIGNED_RESERVATION_REMOVED_FROM_GROUP = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.UNASSIGNED_RESERVATION_REMOVED_FROM_GROUP,
    () => $t('Unassigned reservation removed from group'),
  )
  static readonly NO_SHOW_REPORTED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.NO_SHOW_REPORTED,
    () => $t('No-show reported'),
  )
  static readonly RESERVATION_CONVERSION = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.RESERVATION_CONVERSION,
    () => $t('Reservation conversion'),
  )
  static readonly VOUCHER_SENT = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.VOUCHER_SENT,
    () => $t('Voucher sent'),
  )
  static readonly CREDIT_CARD_DISPLAYED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.CREDIT_CARD_DISPLAYED,
    () => $t('Credit card displayed'),
  )
  static readonly CREDIT_CARD_DELETED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.CREDIT_CARD_DELETED,
    () => $t('Credit card deleted'),
  )
  static readonly CREDIT_CARD_REPORTED_INVALID = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.CREDIT_CARD_REPORTED_INVALID,
    () => $t('Credit card reported invalid'),
  )
  static readonly CREDIT_CARD_CANCELLATION_REPORTED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.CREDIT_CARD_CANCELLATION_REPORTED,
    () => $t('Credit card cancellation reported'),
  )
  static readonly INVOICE_CREATED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.INVOICE_CREATED,
    () => $t('Invoice created'),
  )
  static readonly INVOICE_UPDATED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.INVOICE_UPDATED,
    () => $t('Invoice updated'),
  )
  static readonly INVOICE_DELETED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.INVOICE_DELETED,
    () => $t('Invoice deleted'),
  )
  static readonly INVOICE_SENT = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.INVOICE_SENT,
    () => $t('Invoice sent'),
  )
  static readonly INVOICE_ASSIGNED_TO_RESERVATION = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.INVOICE_ASSIGNED_TO_RESERVATION,
    () => $t('Invoice assigned to reservation'),
  )
  static readonly INVOICE_REMOVED_FROM_RESERVATION = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.INVOICE_REMOVED_FROM_RESERVATION,
    () => $t('Invoice removed from reservation'),
  )
  static readonly BONUS_APPROVAL = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.BONUS_APPROVAL,
    () => $t('Bonus approval'),
  )
  static readonly EQC_SEND = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.EQC_SEND,
    () => $t('EQC send'),
  )
  static readonly PAYMENT_CREATED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.PAYMENT_CREATED,
    () => $t('Payment created'),
  )
  static readonly PAYMENT_DELETED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.PAYMENT_DELETED,
    () => $t('Payment deleted'),
  )
  static readonly EMAIL_SENT = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.EMAIL_SENT,
    () => $t('Email sent'),
  )
  static readonly SMS_SENT = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.SMS_SENT,
    () => $t('SMS sent'),
  )
  static readonly AIRBNB_MESSAGE = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.AIRBNB_MESSAGE,
    () => $t('Airbnb message'),
  )
  static readonly BOOKING_COM_MESSAGE = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.BOOKING_COM_MESSAGE,
    () => $t('Booking.com message'),
  )
  static readonly CONTACT_PERSON_ADDED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.CONTACT_PERSON_ADDED,
    () => $t('Contact person added'),
  )
  static readonly CONTACT_PERSON_UPDATED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.CONTACT_PERSON_UPDATED,
    () => $t('Contact person updated'),
  )
  static readonly CONTACT_PERSON_REMOVED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.CONTACT_PERSON_REMOVED,
    () => $t('Contact person removed'),
  )
  static readonly CONTACT_PERSON_CREATED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.CONTACT_PERSON_CREATED,
    () => $t('Contact person created'),
  )
  static readonly CONTACT_PERSON_RECORD_UPDATED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.CONTACT_PERSON_RECORD_UPDATED,
    () => $t('Contact person record updated'),
  )
  static readonly CONTACT_PERSON_DELETED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.CONTACT_PERSON_DELETED,
    () => $t('Contact person deleted'),
  )
  static readonly NOTE_ADDED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.NOTE_ADDED,
    () => $t('Note added'),
  )
  static readonly NOTE_UPDATED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.NOTE_UPDATED,
    () => $t('Note updated'),
  )
  static readonly NOTE_DELETED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.NOTE_DELETED,
    () => $t('Note deleted'),
  )
  static readonly RESERVATION_NOTE_ADDED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.RESERVATION_NOTE_ADDED,
    () => $t('Reservation note added'),
  )
  static readonly RESERVATION_NOTE_UPDATED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.RESERVATION_NOTE_UPDATED,
    () => $t('Reservation note updated'),
  )
  static readonly RESERVATION_NOTE_DELETED = new ReservationHistoryRecordType(
    ReservationHistoryRecordTypeId.RESERVATION_NOTE_DELETED,
    () => $t('Reservation note deleted'),
  )
  private constructor(
    public readonly id: ReservationHistoryRecordTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
